<template>
  <div>
    <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Evolução</h1>
    <data-table
      v-if="loadTable"
      v-model:columns="columns"
      :route="'/patients/evolutions/' + patient.id"
      no-data-label="Nenhuma evolução cadastrada"
      no-result-label="Nenhuma evolução encontrada"
    >
      <template #after.reload-button>
        <button v-if="user.role == 2" class="flex items-end font-roboto font-medium btn-blue uppercase" @click.prevent="openModalEdit({})">
          <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /><span class="hidden lg:block"> Adicionar Evolução</span>
        </button>
      </template>
    </data-table>
  </div>
  <modal-edit ref="modalEdit" title="Dado Vital" :url="'patients/evolutions/' + patient.id" @submitForm="reloadTable">
    <template #form="{item}">
      <text-input v-model="item.professionalName" class="lg:pr-6 w-full lg:w-1/2" label="Nome do profissional" disabled />
      <date-time-input v-model="item.date" :error="item.errors.date" class="mt-6 lg:mt-0 w-full lg:w-1/2" label="Data e hora" disabled />
      
      <textarea-input v-model="item.chief_complaint" :error="item.errors.chief_complaint" class="mt-6 w-full" label="Queixa Principal" />
      <textarea-input v-model="item.description" :error="item.errors.description" class="mt-6 w-full" label="Evolução" />

      <select-input v-model="item.type" :error="item.errors.type" class="lg:pr-6 mt-6 w-full lg:w-1/2" label="Tipo do Problema" @change="changeCategory">
        <option v-for="(value, name, index) in this.care_plan_types()" :key="name" :value="name">{{ value }}</option>
      </select-input> 

      <lazy-select 
        v-model="item.problem"
        :data="problemList" 
        option-label="id" 
        text-label="description" 
        :error="item.errors.problem" 
        class="mt-6 w-full lg:w-1/2" 
        label="Problema"
        placeholder="Selecione"
        @load-more="loadMoreOptions">
      </lazy-select>
    </template>
  </modal-edit>
</template>

<script>
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import LoadingButton from '@/Shared/LoadingButton'
import ModalDelete from '@/Shared/ModalDelete'
import ModalEdit from '@/Shared/ModalEdit'
import DataTable from '@/Shared/DataTable'
import DateTimeInput from '@/Shared/DateTimeInput'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import VueSelectInput from '@/Shared/VueSelectInput'
import SelectInput from '@/Shared/SelectInput'

import axios from 'axios'
import LazySelect from '@/Shared/LazySelect'

export default {
  inject: ['patient', 'professionalName', 'care_plan_types', 'care_plan_problems' ],
  components: {
    LoadingButton,
    ModalDelete,
    ModalEdit,
    DataTable,
    DateTimeInput,
    TextInput,
    TextareaInput,
    VueSelectInput,
    SelectInput,
    LazySelect,
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  data() {
    return {
      loadTable: true,
      problemList: null,
      links: {
        category: null,
        page: 1,
        per_page: 20,
      },
      columns: [
        {
          uniqid: 'evolution_professional',
          label: 'Profissional',
          field: 'professional_user.name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.id ? row.professional.user.name : ''
        },
        {
          uniqid: 'evolution_description',
          label: 'Descrição',
          field: 'description',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm overflow-hidden',
          headerClass: 'p-4 text-left',
          format: (val, row) => val ? val.substr(0, 50) : ''
        },
        {
          uniqid: 'evolution_chief_complaint',
          label: 'Queixa Principal',
          field: 'chief_complaint',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: ( val, row ) => val || ''
        },
        {
          uniqid: 'evolution_date',
          label: 'Data',
          field: 'date',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => this.$filters.formatDateTime(row.date),
        },
      ],
    }
  },
  methods: {
    getDatetimeString() {
      const date = new Date()
      const datetimeString = date.toLocaleDateString( 'pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit' } ) + ' ' + date.toLocaleTimeString( 'pt-BR', { hour: '2-digit', minute:'2-digit' } )
      return datetimeString.replace( /(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1' )
    },

    openModalEdit(item) {
      this.$refs.modalEdit.openModalEdit({
        id: item.id,
        title: item.title,
        description: item.description,
        chief_complaint: item.chief_complaint,
        date: item.date ?? this.getDatetimeString(),
        professional: item.professional ?? null,
        professionalName: this.professionalName(),
        type: item.type,
        problem: item.problem,
      });
    },
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    },

    changeCategory( $event ) {
      this.links.category = $event.target.value
      this.loadOptions()
    },

    async loadOptions() {
      const response = await axios.get( '/cid/list', { 
        params: this.links
      } )

      this.problemList = response.data.data
    },

    loadMoreOptions() {
      this.links.page += 1;
      this.loadOptions()
    },
  },
}
</script>